import React from 'react';
import { List } from 'semantic-ui-react'
import {flowRight as compose} from 'lodash';
import general from '../../../modulos/general';
import { Form, Button } from 'semantic-ui-react'

import {graphql} from 'react-apollo';

//utils
import queries from '../../../utils/queries'
import XLSX from 'xlsx'
import { saveAs } from 'file-saver';
import TitDer from '../../../components/funcionales/titder';
var moment = require('moment');

// import EstilosHome from '../../css/home.css';

const DetalleNivel1 = ({styles, elemento, handleClickidLista}) => { 
  return (
    <tr className=''>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
        background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.fechaRegPago?elemento.fechaRegPago.substr(0, 10):""}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.usuarioRegPago}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrEmpresa}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.ordenCompraCliente?elemento.ordenCompraCliente:''}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.numOrdenCompra}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.estadoOC}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.numAvance}</td>
      <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.valorPago?new Intl.NumberFormat('de-DE').format(elemento.valorPago):0}</td>
      <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.valorIVA?new Intl.NumberFormat('de-DE').format(elemento.valorIVA):0}</td>
      <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.valorRetencion?new Intl.NumberFormat('de-DE').format(elemento.valorRetencion):0}</td>
      <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.valorAjuste?new Intl.NumberFormat('de-DE').format(elemento.valorAjuste):0}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.observacionAjuste}</td>
    </tr>  
  )
};

const Lista = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento}
        handleClickidLista={handleClickidLista}
        key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class AdminRecaudoLog2 extends React.Component { 
  state = {argsBuscCad: {}, argsDocum: {desde: this.props.fechaHoy, hasta: this.props.fechaFin},
    argsQuery: `{$match: {fechaRta: { $gte: new Date('2023-10-01')}, tipoCoti: 'Cliente', estadoOC: {$in: ['Prefactura', 'Aprobada', 'Factura', 'Pagada']}}},
    {"$unwind": "$itemsPagos"},
      {$project: {numOrdenCompra: 1, numCoti: 1, descrEmpresa: 1, pais: 1, monedaCoti: 1, 
        estadoOC: 1, nombreUsuario: 1, nombreUsuarioOC: 1, ordenCompraCliente: 1, fechaRta: 1, valorPago: '$itemsPagos.valorPago', 
        valorAjuste: '$itemsPagos.valorAjuste', valorRetencion: '$itemsPagos.valorRetencion', valorIVA: '$itemsPagos.valorIVA', 
        codiAvance: {"$toString": "$itemsPagos.codiAvance"}, usuarioRegPago: '$itemsPagos.usuarioRegPago',
        fechaRegPago: '$itemsPagos.fechaRegPago', observacionAjuste: '$itemsPagos.observacionAjuste'}},
    {$lookup: {from: 'usuarios', localField: 'usuarioRegPago', foreignField: 'email', as: 'usuario'}},
    {$unwind: '$usuario'},
    {$project: {_id: {$concat: ['$numCoti', '$codiAvance']}, numOrdenCompra: 1, numCoti: 1, descrEmpresa: 1, pais: 1, monedaCoti: 1, 
      estadoOC: 1, nombreUsuario: 1, nombreUsuarioOC: 1, ordenCompraCliente: 1, fechaRta: 1, valorPago: 1, valorIVA: 1, 
      valorAjuste: 1, valorRetencion: 1, codiAAvance: 1, fechaRegPago: 1, observacionAjuste: 1, usuarioRegPago: '$usuario.nombreUsuario'}},
    {$sort: {fechaRegPago: -1}}`
  }

  async componentDidUpdate (prevProps){ 
    if(this.props.argsBuscCad!==prevProps.argsBuscCad){
      let argsBuscar = `'tipoCoti': 'Cliente'`
      if(this.props.argsBuscCad.pais){
        argsBuscar += `, 'pais': /${this.props.argsBuscCad.pais}/i`
      }
      if(this.props.argsBuscCad.descrEmpresa){
        argsBuscar += `, 'descrEmpresa': /${this.props.argsBuscCad.descrEmpresa}/i`
      }          
      if(this.props.argsBuscCad.numCoti){
        argsBuscar += `, 'numCoti': /${this.props.argsBuscCad.numCoti}/i`
      }
      if(this.props.argsBuscCad.numOrdenCompra){
        argsBuscar += `, 'numOrdenCompra': /${this.props.argsBuscCad.numOrdenCompra}/i`
      }
      if(this.props.argsBuscCad.ordenCompraCliente){
        argsBuscar += `, 'ordenCompraCliente': /${this.props.argsBuscCad.ordenCompraCliente}/i`
      }
     
      let argsBuscCad = `{$match: {${argsBuscar}}}`
      let argsBuscarIt = {tipoqry: `[${this.state.argsQuery}, ${argsBuscCad}]`}
      console.log(argsBuscarIt)
      await this.props.allCotizacionRtesFacLog.refetch(argsBuscarIt)
    }
  }

  handleGenExc = async (ev, list)=>{
    if(list.length>0){
      document.body.style.cursor = 'wait'
      //Archivo Excel
      let xlsString = []
      let xlsString1 = []
      xlsString1 = ['FECHA VENTA', 'FECHA RECAUDO', 'CLIENTE', 'PAIS', 'COMERCIAL', 'MONEDA', 'COTIZACION', 'OC CLIENTE', 'OC LCM', '# AVANCE', 'ESTADO OC', 
      'RECAUDO', 'IMPUESTO', 'RETENCION', 'AJUSTE', 'OBSERVACION AJUSTE', 'USUARIO RECAUDO']
      xlsString.push(xlsString1)

      for (let iiii=0;iiii<list.length;iiii++){
        xlsString1 = [list[iiii].fechaRta.substr(0, 10), list[iiii].fechaRegPago.substr(0, 10), list[iiii].descrEmpresa, list[iiii].pais?list[iiii].pais:'', list[iiii].nombreUsuario, 
            list[iiii].monedaCoti?list[iiii].monedaCoti:'', list[iiii].numCoti, list[iiii].ordenCompraCliente, 
            list[iiii].numOrdenCompra, list[iiii].codiAvance, list[iiii].estadoOC, list[iiii].valorPago, 
            list[iiii].valorIVA?list[iiii].valorIVA:0, list[iiii].valorRetencion?list[iiii].valorRetencion:0, 
            list[iiii].valorAjuste?list[iiii].valorAjuste:0, list[iiii].observacionAjuste, list[iiii].usuarioRegPago?list[iiii].usuarioRegPago:'']
        xlsString.push(xlsString1)

        if(iiii===list.length-1){
          var wb = XLSX.utils.book_new();

          wb.Props = {
            Title: "SheetJS Tutorial",
            Subject: "Test",
            Author: "Red Stapler",
            CreatedDate: new Date(2017,12,19)
          };

          wb.SheetNames.push("Recaudo");

          let ws_data = xlsString;

          let ws = XLSX.utils.aoa_to_sheet(ws_data);
          wb.Sheets["Recaudo"] = ws;
          let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
          function s2ab(s) { 
            let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
            let view = new Uint8Array(buf);  //create uint8array as viewer
            for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
            return buf;    
          }
          saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'RECAUDO_LCM.xlsx');
//FIN Exportar a XLS
        }

        document.body.style.cursor = 'default'

        this.setState({open: false, confirmaAct: false})
      }
    }
  }

  
  render(){
    const {argsDocum, confirmaAct} = this.state;

    let list = []
    if(this.props.allCotizacionRtesFacLog.allCotizacionRtes){list = this.props.allCotizacionRtesFacLog.allCotizacionRtes}

    const a355505 = this.props.autorizacUA.findIndex( autorizac => autorizac === "355505" );
    const a355510 = this.props.autorizacUA.findIndex( autorizac => autorizac === "355510" );
    // if(a355505!==-1){
    //   list = list.filter(elemento => elemento.pais==='Colombia')
    // }else{
    //   if(a355510!==-1){
    //     list = list.filter(elemento => elemento.pais==='Panamá')
    //   }
    // }

    return (
      <div>
        <List selection>
          <TitDer list={list} textBoton1="Bitacora de facturación" btnNuevo={"NO"} styles={this.props.styles}/>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, list, argsDocum):()=>{}}>
            <div className="ui one column stackable grid">
              <div className="column" style={{width: '30%', paddingTop: '0.0em'}}>
                <br></br>
                <Button id="excel" name="excel" style={this.props.styles.confirmar} onClick={(ev)=>this.handleGenExc(ev, list)} fluid>
                  Exportar a excel
                </Button>
              </div>
            </div>
            <div>
              <div style={{height: '35em', overflow: 'auto'}}>
                <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      {/* <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>Tipo</th> */}
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '9%'}}>Fecha recaudo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>Usuario recaudo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>Cliente</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>OC Cliente</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>OC LCM</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Estado OC</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}># Avance</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Recaudo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Impuesto</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Retención</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '9%'}}>Ajuste</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '9%'}}>Observacion ajuste</th>
                    </tr>
                  </thead>
                  <Lista list={list} handleClickidLista={this.props.handleClickidLista}/>
                </table>
                <p></p>
              </div>
            </div>
          </Form>
        </List>

      </div>
    )
  }
};
 
export default compose( 
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtesFacLog',
    options: (props) => {return {variables: {tipoqry: `[{$match: {fechaRta: { $gte: new Date('2023-10-01')}, tipoCoti: 'Cliente', estadoOC: {$in: ['Prefactura', 'Aprobada', 'Factura', 'Pagada']}}},
    {"$unwind": "$itemsPagos"},
      {$project: {numOrdenCompra: 1, numCoti: 1, descrEmpresa: 1, pais: 1, monedaCoti: 1, 
        estadoOC: 1, nombreUsuario: 1, nombreUsuarioOC: 1, ordenCompraCliente: 1, fechaRta: 1, valorPago: '$itemsPagos.valorPago', 
        valorAjuste: '$itemsPagos.valorAjuste', valorRetencion: '$itemsPagos.valorRetencion', valorIVA: '$itemsPagos.valorIVA', 
        codiAvance: {"$toString": "$itemsPagos.codiAvance"}, usuarioRegPago: '$itemsPagos.usuarioRegPago',
        fechaRegPago: '$itemsPagos.fechaRegPago', observacionAjuste: '$itemsPagos.observacionAjuste'}},
    {$lookup: {from: 'usuarios', localField: 'usuarioRegPago', foreignField: 'email', as: 'usuario'}},
    {$unwind: '$usuario'},
    {$project: {_id: {$concat: ['$numCoti', '$codiAvance']}, numOrdenCompra: 1, numCoti: 1, descrEmpresa: 1, pais: 1, monedaCoti: 1, 
      estadoOC: 1, nombreUsuario: 1, nombreUsuarioOC: 1, ordenCompraCliente: 1, fechaRta: 1, valorPago: 1, valorIVA: 1, 
      valorAjuste: 1, valorRetencion: 1, codiAAvance: 1, fechaRegPago: 1, observacionAjuste: 1, usuarioRegPago: '$usuario.nombreUsuario'}},
    {$sort: {fechaRegPago: -1}}
    ]`}}}}),

)(AdminRecaudoLog2) 
